import {Chip, useTheme} from "@mui/material";

const SchoolChip = ({school}: {school: string}) => {
    const theme = useTheme();
    let color = theme.palette.secondary.main;
    if (school === "GBN") {
        color = "#005b38";
    } else if (school === "GBS") {
        color = "#0c234b";
    }

    return (
        <Chip
            label={school}
            size="small"
            sx={{
                height: "24px",
                bgcolor: color,
                color: "#f5f5f5",
            }}
        />
    );
};

export default SchoolChip;
